<!-- address.calendar.day.html !-->
<div class="addressday  esunlink" [ngStyle]="getDayStyle()" (click)="dayclick()">
    <div class="star" [ngClass]="{'show' : getShwoStart()}">*</div>
    <div class="detail">
        {{ value.skin }}
    </div>
</div>